import { OptionsFloatings } from '@comfama/comfama-ui-react';
import React, { useEffect, useState } from 'react';
import { adaptToOptionFloating } from './serviceChannelsAdapter';

const ServiceChannels: React.FC = () => {
    const [serviceChannelsInfo, setServiceChannelsInfo] = useState<any>(null);

    useEffect(() => {
        const fetchServiceChannelsData = async () => {
            try {
                const response = await fetch('/components/chatbot-info.json');
                const rawData = await response.json();
                const adaptedData = adaptToOptionFloating(rawData)
                setServiceChannelsInfo(adaptedData);
            } catch (error) {
                console.error('Error fetching chatbot info:', error);
            }
        };

        fetchServiceChannelsData();
    }, []);

    return (
        <>
            {serviceChannelsInfo ? (
                <OptionsFloatings channels={serviceChannelsInfo} buttonPosition="bottom-right" />
            ) : (
                <></>
            )}
        </>
    );
};

export default ServiceChannels;
